<template>
  <v-menu
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :value="showBadge"
        :content="count"
        class="white--text"
        color="primary"
      >
        <v-btn v-bind="attrs" v-on="on" color="primary" small outlined>
          <v-icon dense x-small left>fa-filter</v-icon>
          Filtrar
        </v-btn>
      </v-badge>
    </template>
    <div class="d-flex flex-column px-6 py-4" :style="'gap: 16px; background-color: white'">
      <v-text-field
        v-for="item in inputs"
        :key="item.key"
        :value="pagamentoItensFilters[item.key]"
        :label="item.label"
        @input="event => debouncedFilterChange(item.key, event)"
        outlined
        clearable
        dense
        hide-details
      />
      <v-checkbox
        :value="pagamentoItensFilters['onlyPositiveValorGlosado']"
        @change="glosaCheckboxChange"
        class="mt-0"
        label="Ocultar itens sem glosa"
      />
    </div>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data () {
    return {
      inputs: [
        { key: 'codigoProcedimento', label: 'Código procedimento' },
        { key: 'codigoTabela', label: 'Código tabela' },
        { key: 'descricaoProcedimento', label: 'Descrição procedimento' },
        { key: 'valorInformado', label: 'Valor informado' },
        { key: 'valorPago', label: 'Valor pago' },
        { key: 'valorGlosado', label: 'Valor glosado' },
      ]
    }
  },
  computed: {
    ...mapState('conciliacao', ['pagamentoItensFilters']),
    count () {
      return Object.values(this.pagamentoItensFilters)
        .filter(value => Boolean(value))
        .length
    },
    showBadge () {
      return this.count > 0
    }
  },
  methods: {
    debouncedFilterChange (key, value) {
      clearTimeout(this._timerId)

      this._timerId = setTimeout(() => {
        this.$store.dispatch('conciliacao/partialUpdatePagamentoItensFilters', { [key]: value })
      }, 500)
    },
    glosaCheckboxChange (value) {
      const payload = {
        onlyPositiveValorGlosado: value ? value : undefined
      }

      this.$store.dispatch('conciliacao/partialUpdatePagamentoItensFilters', payload)
    }
  },
  beforeDestroy () {
    clearTimeout(this._timerId)
  }
}
</script>
